import Swiper from 'swiper/bundle'
import $ from 'jquery'

// The two property heroes defer every slide but the visible one — see
// docs/rentals/hero-images.md. A factory rather than a shared literal, so each
// instance owns its params: warmNeighbourAfterHero mutates loadPrevNext.
const propertyHeroLazy = () => ({
    enabled: true,
    loadPrevNext: false,
    loadOnTransitionStart: true,
});

// Keyed to the hero's own load rather than window.load, which also waits on
// third-party widgets and every below-the-fold image — routinely longer than
// the 3s autoplay tick that would then land on the placeholder.
function warmNeighbourAfterHero(swiper) {
    const warm = () => {
        if (swiper.destroyed) {
            return;
        }

        swiper.params.lazy.loadPrevNext = true;
        swiper.lazy.load();
    };

    const firstSlide = swiper.slides.length ? swiper.slides[0] : null;
    const hero = firstSlide && firstSlide.querySelector('img.property-hero__img:not(.swiper-lazy)');

    if (!hero || hero.complete) {
        warm();

        return;
    }

    hero.addEventListener('load', warm, { once: true });
    // Warm on error too, so a missing hero cannot wedge the rest of the carousel.
    hero.addEventListener('error', warm, { once: true });
}

new Swiper('.swiper-hotel-hero', {
    autoplay: true,
    lazy: propertyHeroLazy(),
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
    },
    on: {
        afterInit: warmNeighbourAfterHero,
    },
});

new Swiper('.swiper-resort-hero', {
    effect: 'fade',
    speed: 500,
    lazy: propertyHeroLazy(),
    autoplay: {
        delay: 10000,
    },
    fadeEffect: {
        crossFade: true,
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
    },
    on: {
        afterInit: warmNeighbourAfterHero,
        slideChange(swiper) {
            dispatchEvent(new CustomEvent('resort-hero-change', { detail: swiper }))
        },
    },
});

new Swiper('.swiper-vpl-landing-resorts', {
    spaceBetween: 20,

    breakpoints: {
        // xs
        360: {
            slidesPerView: 1,
            spaceBetween: 10
        },
        // sm
        640: {
            slidesPerView: 2,
            spaceBetween: 10
        },
        // lg
        1024: {
            slidesPerView: 3,
            spaceBetween: 20
        },
        // xl
        1280: {
            slidesPerView: 4,
            spaceBetween: 20
        }
    },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

new Swiper('.swiper-vpl-landing-testimonials', {
    loop: true,
    spaceBetween: 100,

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

new Swiper('.swiper-vpl-hero', {
    effect: 'fade',
    speed: 500,
    autoplay: {
        delay: 5000,
    },
    fadeEffect: {
        crossFade: true,
    },
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
    },
    on: {
        slideChange(swiper) {
            dispatchEvent(new CustomEvent('vpl-hero-change', { detail: swiper }))
        },
    },
});

const $swiperPointsCharts = $('.swiper-points-charts')
if ($swiperPointsCharts.length) {
    new Swiper($swiperPointsCharts[0], {
        autoHeight: true,
        initialSlide: $swiperPointsCharts.data('initial-slide') || 0,

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        spaceBetween: 16,
        breakpoints: {
            768: {
                spaceBetween: 0,
            },
        },
    });
}

// Swiper nav/pagination are rapid-click by design; the class keeps them out of
// PostHog rageclick detection (docs/integrations/posthog.md, "Rageclick
// Suppression"). Done here once rather than per template: Swiper's a11y labels
// would only cover them by accident, and pagination bullets are runtime-built.
document
    .querySelectorAll('.swiper-button-next, .swiper-button-prev, .swiper-pagination')
    .forEach((el) => el.classList.add('ph-no-rageclick'));
